var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"calss":"main"}},[(_vm.getView===''||_vm.getView==='home')?_c('Home'):(_vm.getView==='heating')?_c('Heating'):(_vm.getView==='plumber')?_c('Plumber'):(_vm.getView==='roof')?_c('Roof'):(_vm.getView==='sanitary')?_c('Sanitary'):(_vm.getView==='imprint')?_c('Imprint'):(_vm.getView==='dataSec')?_c('DataSecurity'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }